import { render, staticRenderFns } from "./BoxStoreComparison.vue?vue&type=template&id=18080fec&scoped=true&"
import script from "./BoxStoreComparison.vue?vue&type=script&lang=js&"
export * from "./BoxStoreComparison.vue?vue&type=script&lang=js&"
import style0 from "./BoxStoreComparison.vue?vue&type=style&index=0&id=18080fec&prod&lang=css&"
import style1 from "./BoxStoreComparison.vue?vue&type=style&index=1&id=18080fec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18080fec",
  null
  
)

/* custom blocks */
import block0 from "./BoxStoreComparison.vue?vue&type=custom&index=0&blockType=i18n&locale=en-us&lang=yaml"
if (typeof block0 === 'function') block0(component)
import block1 from "./BoxStoreComparison.vue?vue&type=custom&index=1&blockType=i18n&locale=ja&lang=yaml"
if (typeof block1 === 'function') block1(component)

export default component.exports
import {QBtnToggle,QTabPanels,QTabPanel,QSelect,QChip,QAvatar} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QBtnToggle,QTabPanels,QTabPanel,QSelect,QChip,QAvatar})
